import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import UserPickerEdit from '@atlassian/jira-issue-field-base-user-picker/src/ui/edit/index.tsx';
import { closeMenuOnScroll } from '../../../../utils/select/index.tsx';
import { validateUserPickerField } from '../../../../utils/validators/index.tsx';
import { withFormField } from '../../../with-form-field/index.tsx';
import { FieldContainer } from '../../styled.tsx';
import type { Props, UserPickerFieldConfig, FieldValue } from './types.tsx';
import { transformDefaultUserValues } from './utils.tsx';

const getAutoCompleteUrl = (context: string, fieldId: string, projectKey: string | undefined) =>
	`/rest/api/3/user/recommend?${new URLSearchParams({
		context,
		...(projectKey && { project: projectKey }),
		...(fieldId && { fieldId }),
		query: '',
	})}`;

const UserPickerField = (props: Props) => {
	const {
		width,
		fieldProps: { value, onChange, id },
		isMulti,
		autoFocus = false,
		fieldId,
		placeholder = ' ',
		isDisabled = false,
		isReadOnly = false,
		onFetchSuggestions,
		isDropdownMenuFixedAndLayered = false,
		context,
		selectedProject,
		projectKey,
	} = props;

	return (
		<FieldContainer width={width}>
			<UserPickerEdit
				autoCompleteUrl={getAutoCompleteUrl(
					context,
					fieldId,
					// this is for fixing an issue that the custom user picker doesn't show the right user group in form when the project key is missing
					fg('jira_forms_fix_user_picker_missing_project_key')
						? projectKey || selectedProject?.projectKey
						: selectedProject?.projectKey,
				)}
				placeholder={placeholder}
				isDisabled={isReadOnly || isDisabled}
				onChange={onChange}
				value={value}
				appearance="normal"
				isMulti={isMulti}
				autoFocus={autoFocus}
				fieldId={fieldId}
				fetchSuggestions={onFetchSuggestions}
				isClearable
				width={width}
				inputId={id}
				onCloseMenuOnScroll={closeMenuOnScroll}
				isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
			/>
		</FieldContainer>
	);
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mapUserOptionsToIds, mapUserOptionsToAccountIds } from './utils';

export default withFormField({
	validator: validateUserPickerField,
	transformDefaultValue: transformDefaultUserValues,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<UserPickerFieldConfig, LegacyValue<UserOption>>, any>'.
})<UserPickerFieldConfig, FieldValue>(UserPickerField);
